module.exports = __webpack_public_path__ + "img/store_bg.14a20053.jpg";